<template lang="">
  <div class="dropdown">
    <button class="dropdown-toggle" aria-expanded="false">
      <h1 style="display: inline-flex !important">
        Ordenar por: {{ optionSelect }} <ChevronDownIcon />
      </h1>
    </button>
    <div class="dropdown-menu w-48">
      <div class="dropdown-menu__content box p-2">
        <a
          href="javascript:;"
          class="items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md font-poppins"
          :class="{ 'bg-gray-200': orderBy === 'createdAtDesc' }"
          @click="$emit('update:orderBy', 'createdAtDesc')"
        >
          Lo más nuevo
        </a>
        <a
          href="javascript:;"
          class="items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md font-poppins"
          :class="{ 'bg-gray-200': orderBy === 'priceAsc' }"
          @click="$emit('update:orderBy', 'priceAsc')"
        >
          Precio: de más bajo a más alto
        </a>
        <a
          href="javascript:;"
          class="items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md font-poppins"
          :class="{ 'bg-gray-200': orderBy === 'priceDesc' }"
          @click="$emit('update:orderBy', 'priceDesc')"
        >
          Precio: de más alto a más bajo
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue'
export default defineComponent({
  setup() {
    const show = () => {
      cash('#programmatically-dropdown').dropdown('show')
    }
    const hide = () => {
      cash('#programmatically-dropdown').dropdown('hide')
    }
    const toggle = () => {
      cash('#programmatically-dropdown').dropdown('toggle')
    }
    return {
      show,
      hide,
      toggle
    }
  },
  props: {
    orderBy: {
      type: String,
      default: undefined
    }
  },
  computed: {
    optionSelect() {
      switch (this.orderBy) {
        case 'createdAtDesc':
          return 'Lo más nuevo'
        case 'priceAsc':
          return 'Precio: de más bajo a más alto'
        case 'priceDesc':
          return 'Precio: de más alto a más bajo'
        default:
          return ''
      }
    }
  },
  emits: ['update:orderBy']
})
</script>
